import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PolicyApiModels } from 'models/api/policy-api.models';
import { TableModels } from 'models/table.models';
import { Observable, of } from 'rxjs';
import { AgencyApiModels } from '../../../../../models/api/agency-api.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class BrokerApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'brokers');
  }

  setAllowedProduct(brokerId: number, rights: number[]) {
    return this.post(`/${brokerId}/allowedProducts`, { rights });
  }

  getAgencyDetails(): Observable<AgencyApiModels.AgencyDetailsResponse> {
    let agencyDetails: AgencyApiModels.AgencyDetailsResponse = {
      publicId: 'BKA08909B6BF1',
      status: 3,
      address: {
        streetName: 'du Château des Rentiers',
        streetNumber: 24,
        streetType: 'Rue',
        repetition: '',
        cityName: 'Paris',
        cityZipCode: '75013',
        complement: '',
      },
      headOfAgency: {
        civility: 1,
        firstName: 'Pierre',
        function: 'Président',
        lastName: 'DUPONT',
        phone: '0111111111',
        mobile: '0666666666',
        email: '1103@wazari-anonym.fr',
      },
      name: 'ZENITH  ASSURANCES',
      companyType: 2,
      numSiret: '40167396700063',
      numSiren: '401673967',
      turnover: 0,
      outletCount: 1,
      employeeCount: 1,
      attestationUrl: '',
      mainBroker: {
        id: 1540,
        ageoId: 'BKA08909B6BF1_1540',
        brokerFirstName: 'HAMICHE',
        brokerLastName: 'Dupont',
        brokerEmail: 'email1539@wazari.fr',
      },
      minInsertDate: '2025-07-01',
      agencyRetentionHealthServiceModels: [],
      agencySpecificitiesHealthServiceModels: [],
      healthSettings: null,
      productAdministration: null,
      waitingMetrics: null,
      fidelityWithholdingMetrics: null,
      acheelWithholdingMetrics: null,
      infinityWithholdingMetrics: null,
      ropWithholdingMetrics: null,
      companyCreationDate: null,
      autoSettings: null,
    };

    return of(agencyDetails);
  }

  getComplements(request: TableModels.PaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<PolicyApiModels.ComplementTableRow>
    >('/complements', {
      ...request,
    });
  }

  getUnpaidReceipts(request: TableModels.PaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<PolicyApiModels.UnpaidReceiptsTableRow>
    >('/unpaidReceipts', {
      ...request,
    });
  }

  archiveSubBroker(subBrokerId: number) {
    return this.delete(`/${subBrokerId}/`, {});
  }
}
